"use client";
import { getGizmoSession } from "@/lib/gizmoSession";
import { getStorage, ref, uploadBytes } from "firebase/storage";
import { getFirestore, doc, setDoc } from "firebase/firestore";
import firebase_app from "@/firebase/config";
import { KibbeFlowError, KibbeDraft, KIBBE_FLOW, saveKibbeDraft, trackKibbe } from "./kibbeClient";
import { kibbePreferencesSchema } from "./kibbe";

export async function createKibbeCheckout(draft: KibbeDraft, returnPath: string, promoCode?: string | null) {
  const preferences = kibbePreferencesSchema.parse(draft.preferences);
  if (!draft.image || (draft.includeColor && !draft.portrait)) throw new KibbeFlowError("photo");
  saveKibbeDraft(draft);
  const uploadId = `kibbe_${crypto.randomUUID()}`;
  const storage = getStorage(firebase_app);
  const upload = async (image: string, name: string) => {
    const blob = await (await fetch(image)).blob();
    await uploadBytes(ref(storage, `generatedKibbeAnalyses/${uploadId}/${name}`), blob, { contentType: "image/jpeg" });
  };
  await upload(draft.image, "image_1.jpg");
  if (draft.includeColor) await upload(draft.portrait, "color_portrait.jpg");
  await setDoc(doc(getFirestore(firebase_app), "generatedKibbeAnalyses", uploadId), {
    analysisId: uploadId, status: "PENDING_PAYMENT", flowVersion: KIBBE_FLOW, createdAt: new Date(),
    formData: { heightCm: preferences.heightCm, preferences }, hasColorPortrait: draft.includeColor,
  });
  const response = await fetch("/api/stripe/createStripeCheckoutPage", { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ gizmoSession: getGizmoSession(), type: "kibbe-analysis", flowVersion: KIBBE_FLOW, prePaymentSessionId: uploadId, includeAnalysis: draft.includeColor, cancelPagePath: returnPath, promoCode: promoCode || undefined }) });
  const data = await response.json();
  if (!response.ok || typeof data.url !== "string") throw new KibbeFlowError("checkout");
  const url = new URL(data.url);
  if (url.protocol !== "https:" || url.hostname !== "checkout.stripe.com") throw new KibbeFlowError("checkout");
  trackKibbe("checkout_redirect", { color_addon: draft.includeColor });
  return url.href;
}
